export default __webpack_public_path__ + "static/media/6s.3fd02805.png";